import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPayableRegister from "../Forms/AddPayablesRegister/AddPayableRegister";
import UploadPayableFile from "../Forms/UploadPayableFile/UploadPayableFile";
import PayableUploadedFiles from "../Forms/PayableUploadedFiles/PayableUploadedFile";
import ColumnMapping from "../Forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../Forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import {
  getPayableListing,
  getPayable,
  getAllPayablesErpData,
  putPayableFromERP,
} from "../../../Bookclosure/Services/ApiHandler";
import receCss from "../../css/receivablesListing.module.css";
import { ReactComponent as CalenderIcon } from "../../assets/icons/Calendar.svg";
import styles from "./Header.module.css";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ErrorPopup";
import SuccessPopup from "../SuccessPopup";
import DeletePopup from "../DeletePopup";
const PayablesHeaders = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
  PayableID,
  appliedFilters: parentAppliedFilters,
}) => {

  const location = useLocation();
  const { asOnDate: passedAsOnDate } = location.state || {};
  const [asOnDate, setAsOnDate] = useState(passedAsOnDate || "");
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPayableUploadedFiles, setShowPayableUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(parentAppliedFilters || []);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);
  const [erpList, setErpList] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
  const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, title: "Are you sure?", message: "", fileIndex: null });

  useEffect(() => {
    if (parentAppliedFilters !== undefined) {
      setAppliedFilters(parentAppliedFilters);
    }
  }, [parentAppliedFilters]);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);
  const [columnMappingData, setColumnMappingData] = useState({});
  const [perFileMappingData, setPerFileMappingData] = useState({});
  const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        if (!PayableID) return;

        const savedTableType = sessionStorage.getItem(`tableType_${PayableID}`);
        if (savedTableType) {
          setShowTable(true);
          setShowDataState(false);
          setTableType(savedTableType);
        }

        const response = await getPayableListing(PayableID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data) {
          if (response.data.filterAndAlignment) {
            setFilterConfig(response.data.filterAndAlignment);
          }
          if (response.data.payableListing && response.data.payableListing.length > 0) {
            setShowTable(true);
            setShowDataState(false);
            if (!savedTableType) {
              setTableType("excel");
              sessionStorage.setItem(`tableType_${PayableID}`, "excel");
            }
          } else if (!savedTableType) {
            try {
              const erpRes = await getAllPayablesErpData(PayableID);
              const list =
                erpRes.data?.ERPPayablesList ||
                erpRes.data?.ERPPayableList ||
                erpRes.data?.data ||
                (Array.isArray(erpRes.data) ? erpRes.data : []);
              if (list && list.length > 0) {
                setShowTable(true);
                setShowDataState(false);
                setTableType("erp");
                sessionStorage.setItem(`tableType_${PayableID}`, "erp");
              }
            } catch (e) {
              // ignore
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (PayableID) {
      fetchFilterConfig();
    }
  }, [PayableID]);

  useEffect(() => {
  if (!passedAsOnDate && PayableID) {
    getPayable(PayableID).then((res) => {
      const data = res.data.Payable?.[0];
      if (data?.asOnDate) {
        setAsOnDate(data.asOnDate);
      }
    });
  }
}, [PayableID, passedAsOnDate]);

  const handleRemoveFile = (index) => {
    const file = uploadedFiles[index];
    const fileName =
      file?.displayName ||
      file?.name ||
      file?.fileName ||
      file?.originalname ||
      file?.rawFile?.name ||
      "this file";
    setDeletePopup({
      isOpen: true,
      title: "Are you sure?",
      message: `Once deleted, you will not be able to recover "${fileName}"!`,
      fileIndex: index,
    });
  };

  const handleConfirmDeleteFile = () => {
    if (deletePopup.fileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.filter((_, i) => i !== deletePopup.fileIndex)
      );
    }
    setDeletePopup({
      isOpen: false,
      title: "Are you sure?",
      message: "",
      fileIndex: null,
    });
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setAppliedFilters(filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = async (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
      setIsErpLoading(true);
      try {
        const res = await getAllPayablesErpData(PayableID);
        const list =
          res.data?.ERPPayableList ||
          res.data?.ERPPayablesList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);
        if (list && list.length > 0) {
          setErpList(list);
        } else {
          setErpList([
            {
              _id: "5eed000000000000000000d2",
              name: "Sample Payable ERP Package",
              createdAt: new Date().toISOString(),
              userName: "Admin",
            },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch ERP payables:", error);
        setErpList([
          {
            _id: "5eed000000000000000000d2",
            name: "Sample Payable ERP Package",
            createdAt: new Date().toISOString(),
            userName: "Admin",
          },
        ]);
      } finally {
        setIsErpLoading(false);
      }
    }
  };

  const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setShowUploadFileModal(false);
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPayableUploadedFiles(false);
  };

  const handleProceedToPayableUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      const fileId = `${computedName}-${file?.size || 0}-${file?.lastModified || 0}`;

      return {
        id: fileId,
        rawFile: file,
        displayName: computedName,
        isMapped: false,
        mappedValues: {},
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowPayableUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    const file = uploadedFiles[index];
    const mappedFromFile = file?.mappedValues || perFileMappingData[file?.id] || {};
    setColumnMappingData(mappedFromFile);
    setShowPayableUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleResetMapping = (index) => {
    const file = uploadedFiles[index];
    const fileId = file?.id;
    setUploadedFiles((prev) =>
      prev.map((f, idx) =>
        idx === index
          ? { ...f, isMapped: false, mappedValues: {} }
          : f
      )
    );
    if (fileId) {
      setPerFileMappingData((prev) => {
        const updated = { ...prev };
        delete updated[fileId];
        return updated;
      });
    }
    if (selectedFileIndex === index) {
      setColumnMappingData({});
    }
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      const selectedFile = uploadedFiles[selectedFileIndex];
      const fileId = selectedFile?.id;

      setUploadedFiles((prev) =>
        prev.map((file, idx) =>
          idx === selectedFileIndex
            ? { ...file, isMapped: true, mappedValues: columnMappingData }
            : file
        )
      );

      if (fileId) {
        setPerFileMappingData((prev) => ({
          ...prev,
          [fileId]: columnMappingData,
        }));
      }
    }

    setShowSubMapping(false);
    setShowPayableUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowPayableUploadedFiles(true);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      setErrorPopup({
        isOpen: true,
        title: "Mapping Required",
        message: "Please map at least one file before finishing.",
      });
      return;
    }

    setShowPayableUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    if (PayableID) {
      sessionStorage.setItem(`tableType_${PayableID}`, "excel");
    }

    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleSuccessERPModal = async () => {
    if (!selectedCardId) {
      setErrorPopup({
        isOpen: true,
        title: "Selection Required",
        message: "Please select an ERP package to proceed.",
      });
      return;
    }
    try {
      const selectedItem = (erpList || [])
        .flatMap((pkg, pkgIdx) => {
          if (Array.isArray(pkg.data) && pkg.data.length > 0) {
            return pkg.data.map((entry, entryIdx) => ({
              ...entry,
              _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
              packageId: pkg._id || pkg.id,
            }));
          }
          return [pkg];
        })
        .find(
          (i) =>
            i._id === selectedCardId ||
            i.packageId === selectedCardId ||
            i.id === selectedCardId
        );

      const resolvedPackageId =
        selectedItem?.packageId || selectedItem?._id || selectedCardId;

      await putPayableFromERP(PayableID, resolvedPackageId);
      setShowERPModal(false);
      setSelectedCardId(null);
      setShowERPSuccessModal(true);
    } catch (error) {
      console.error("Failed to pull from ERP:", error);
      setErrorPopup({
        isOpen: true,
        title: "Error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to pull ERP data. Please try again.",
      });
    }
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    if (PayableID) {
      sessionStorage.setItem(`tableType_${PayableID}`, "erp");
    }
    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          {/* <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          /> */}

          <div className={receCss.calenderContainer}>
              <div className={receCss.CalenderContainer} style={{ height: "35px" }}>
                <div className={receCss.calenderLabels}>As On</div>
                 {asOnDate && (
                    <div className={receCss.calenderDate}>
                      {formatDate(asOnDate)}
                    </div>
                  )}
                <div className={receCss.calenderIconContainer}>
                  <CalenderIcon />
                </div>
               </div>
          </div> 

          {/* {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )} */}
          {tableType === "erp" && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPayableRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false); 
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPayableFile
          PayableID={PayableID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onChangeFile={handleChangeFile}
          onProceedToPayableUploadedFiles={handleProceedToPayableUploadedFiles}
        />
      )}

      {showPayableUploadedFiles && (
        <PayableUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowPayableUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onAdd={handleAddFiles}
          onStartMapping={handleStartMapping}
          onResetMapping={handleResetMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onClose={() => setShowPayableUploadedFiles(false)}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          key={PayableID}
          PayableID={PayableID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPayableUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onCancel={() => {
            setShowColumnMapping(false);
          }}
          onClose={() => {
            setShowColumnMapping(false);
          }}
          mappedValues={columnMappingData}
          setMappedValues={setColumnMappingData}
        />
      )}

      {showSubMapping && (
        <Submapping
          PayableID={PayableID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onClose={() => {
            setShowSubMapping(false);
          }}
          onCancel={() => {
            setShowSubMapping(false);
          }}
          onMapped={handleSubmappingSuccess}
          onSubmitMapping={handleSubmitSubMapping}
        />
      )}

      {showERPModal && (
        <ERPModal
          erpList={erpList}
          selectedCardId={selectedCardId}
          setSelectedCardId={setSelectedCardId}
          isLoading={isErpLoading}
          onClose={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
          }}
          onBack={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
          appliedFilters={appliedFilters}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}

      <SuccessPopup
        isOpen={successPopup.isOpen}
        title={successPopup.title}
        message={successPopup.message}
        onClose={() =>
          setSuccessPopup({ isOpen: false, title: "Success", message: "" })
        }
      />

      <ErrorPopup
        isOpen={errorPopup.isOpen}
        title={errorPopup.title}
        message={errorPopup.message}
        onClose={() =>
          setErrorPopup({ isOpen: false, title: "Error", message: "" })
        }
      />

      <DeletePopup
        isOpen={deletePopup.isOpen}
        title={deletePopup.title}
        message={deletePopup.message}
        onConfirm={handleConfirmDeleteFile}
        onCancel={() =>
          setDeletePopup({
            isOpen: false,
            title: "Are you sure?",
            message: "",
            fileIndex: null,
          })
        }
      />
    </>
  );
};

export default PayablesHeaders;